import mitt from 'mitt';
import type { ScrollView } from 'react-native';

type Events = {
  'gv-play-verse': { ch: string | number; vs: string | number };
  'gv-recitation-state': { ch?: string | number; vs?: string | number; playing: boolean };
};

export const emitter = mitt<Events>();

/** Shared ref to the center‑pane ScrollView so any component can scroll it. */
export const centerScrollViewRef = { current: null as ScrollView | null };

/** Tracks the current scroll offset of the center pane (for native measure calculations). */
export const centerScrollOffset = { current: 0 };
